export const gotAllGuests = allGuestsData => ({
  type: 'GOT_ALL_GUESTS',
  payload: allGuestsData
})

export const gotActiveGuests = activeGuestsData => ({
  type: 'GOT_ACTIVE_GUESTS',
  payload: activeGuestsData
})

export const gotOptedOutGuests = optedoutGuestData => ({
  type: 'GOT_OPTED_OUT_GUESTS',
  payload: optedoutGuestData
})

export const gotUploadLogs = uploadLogsData => {
  const data = uploadLogsData.map(d => ({ ...d, tab: getTab(d) }))
  const timestamp = new Date().toJSON()

  return {
    type: 'GOT_UPLOAD_LOGS',
    payload: {
      timestamp,
      data
    }
  }
}

export const uploadedGuestData = () => ({
  type: 'UPLOADED_GUEST_DATA'
})

function getTab({ category }) {
  if (
    category === 'ReservationsActivityWithContactDetails' ||
    category === 'ReservationOnlyActivity'
  ) {
    return 'ReservationsAndCancellations'
  }
  if (category === 'CheckoutActivityWithContactDetails') {
    return 'Checkouts'
  }
  return 'Others'
}
